import { render, staticRenderFns } from "./PNotification.vue?vue&type=template&id=b2123e56"
import script from "./PNotification.vue?vue&type=script&lang=js"
export * from "./PNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports